import React, {useState, useEffect, useContext} from 'react';

//import {scaleLinear} from "d3-scale";
import {
  CartesianGrid, ReferenceArea,
  ResponsiveContainer, Tooltip,
  XAxis, YAxis, LineChart, Line, AreaChart, Area
} from "recharts";
import moment from "moment/moment";
import {ZoomContext} from "../contexts/ZoomContext";

const tickLookup = [3600*1000*24*182, 3600*1000*24*63, 3600*1000*24*30, 3600*1000*24*14, 3600*1000*24*7, 3600*1000*24*2, 3600*1000*24, 3600*1000*12, 3600*1000*8, 3600*1000*6, 3600*1000*4, 3600*1000*3, 3600*1000*2, 60*60*1000, 45*60*1000, 30*60*1000, 20*60*1000, 10*60*1000, 5*60*1000, 2*60*1000, 60*1000, 40*1000, 30*1000, 20*1000, 10*1000, 5*1000, 4*1000, 2*1000, 1000, 500, 200, 100, 50];

const SmartPlugAreaChart = ({device, formattedData, dataKey, seriesName, seriesMetadata, xAxisTickFormatter, areaName, areaUnit, yAxisName, yAxisTicks, yAxisDomain, yAxisFormatter, color, tooltipFormatter, tooltipLabelFormatter, onDragZoom, containerWidth, containerHeight, style}) => {
  const [refAreaLeft, setRefAreaLeft] = useState('');
  const [refAreaRight, setRefAreaRight] = useState('');
  const { since, until } = useContext(ZoomContext);
  const zoomIntervalMillis = until - since;
  yAxisDomain = yAxisDomain || [0, 10];
  yAxisTicks = yAxisTicks || [];
  containerWidth = containerWidth || "100%";
  containerHeight = containerHeight || "100%";
  seriesName = seriesName || "watts";
  // console.log("Creating SmartPlugAreaChart, device", device.toObject(), zoomIntervalMillis, new Date(since),"<->", new Date(until));

  // console.log("Area chart received", formattedData.length, "measurements for device",
  //     device.getId());
  const [linearDomainMin, linearDomainMax] = [since, until];
  // const linearScale = scaleLinear().domain([linearDomainMin, linearDomainMax]);
  // console.log("linear domain min/max", linearDomainMin, linearDomainMax);
  const durationMillis = linearDomainMax - linearDomainMin;
  const tickInterval = durationMillis / 6;
  // console.log("tick Interval", tickInterval);

  var modInterval = tickLookup.find((e) => tickInterval / 8 >= e);
  var selectedInterval = tickLookup.find((e) => tickInterval >= e);
  // console.log("selected interval", selectedInterval, "modInterval", modInterval);

  // var start = linearDomainMin - (linearDomainMin % modInterval);
  var start = zoomIntervalMillis >= 604800000
      ? moment(linearDomainMin).startOf('day')
      : linearDomainMin - (linearDomainMin % modInterval);
  var end = linearDomainMax;
  var xAxisTicks = [];
  var i = start;
  for (i = start; i < end; i += selectedInterval) {
    xAxisTicks.push(i);
  }
  //
  // let [minW, maxW] = [0, 1];
  // if (formattedData.length > 0) {
  //
  //   // const centiwattsMetadata = seriesMetadata.get("centiwatts");
  //   // [minW, maxW] = [Math.min(minW, centiwattsMetadata.getSeriesMin()/100),
  //   //   Math.max(maxW, centiwattsMetadata.getSeriesMax()/100)];
  // }

  // var tickPowerValues = [];
  // start = minW - (minW % 10);
  // end = (maxW + 10) - (maxW % 10);
  // for (i = start; i <= end; i += 10) {
  //   tickPowerValues.push(i);
  // }

  //console.log("xAxisTicks", xAxisTicks);
  // setTicks(tickValues);
  // setTicksPower(tickPowerValues);

  // console.log(linearScale.ticks(12))

  const zoom = () => {
    let left = refAreaLeft;
    let right = refAreaRight;
    console.log("zoom refAreaLeft", left, "refAreaRight", right);

    // Check if click but didn't drag
    if (left === right || right === '' || !left || !right) {
      setRefAreaLeft('');
      setRefAreaRight('');
      return;
    }

    let percent = Math.abs(Number(right)-Number(left)) / Math.abs(until-since)
    if (percent < 0.02) {
      console.log("Percent", percent, "Too small a percent for zoom, ignoring zoom request");
      setRefAreaLeft('');
      setRefAreaRight('');
      return;
    }

    // xAxis domain
    if (left > right) {
      // user dragged from right to left, swap around so left is always less than right
      [left, right] = [right, left];
    }

    // Reset to hide drag highlight now that mouse up has happened
    setRefAreaLeft('');
    setRefAreaRight('');

    console.log("Percent", percent, "Old since and until", since, until,
        "New since and until", left, right, new Date(left), new Date(right));
    // setIsLoadingChart(true);
    onDragZoom(left, right);
  }

  // const onLegendClick = (e) => {
  //   // Toggle opposite series such that clicking on the legend focuses on that series
  //   if (e.target.name === "humidity-legend") {
  //     setIsPowerEnabled(!isPowerEnabled);
  //   }
  // };

  const tickXFormatter = (unixTime) => {
    if (zoomIntervalMillis >= 604800000) { // 1 week
      return moment(unixTime).format('M/DD')
    } else if (zoomIntervalMillis >= 129600000) { // 36 hours
      return moment(unixTime).format('MM/DD h:mma');
    } else if (zoomIntervalMillis >= 360000) { // 6 minutes
      return moment(unixTime).format('h:mma');
    } else {
      return moment(unixTime).format('h:mm:ssa');
    }
  }

  const tickYPowerFormatter = (value) => value.toFixed(0);

  const tickYHumidityFormatter = (value) => value.toFixed(2);

  const tooltipValuesFormatter = (value, name) => (name === "Time")
      ? moment(value).format('MMM DD, h:mm:ss a')
      : (Math.round(value * 10) / 10).toFixed(1);

  const tooltipDateFormatter = (label, payload) => (label)
      ? (zoomIntervalMillis >= 39*604800000 ? moment(label).format('MMM DD, YYYY h:mm:ss a') : moment(label).format('MMM DD, h:mm:ss a'))
      : label;

  /*
  formattedData
  dataKey
  seriesName
  seriesMetadata
  xAxisTickFormatter={tickXFormatter}
  areaName="Watts"
  areaUnit="W"
  yAxisName="Power (W)"
  yAxisDomain={[0,10]}
  yAxisFormatter={tickYPowerFormatter}
  color="#ff780a"
  tooltipFormatter=tooltipValuesFormatter
  tooltipLabelFormatter=tooltipDateFormatter
   */

  xAxisTickFormatter = xAxisTickFormatter || tickXFormatter;
  yAxisFormatter = yAxisFormatter || tickYPowerFormatter;
  tooltipFormatter = tooltipFormatter || tooltipValuesFormatter;
  tooltipLabelFormatter = tooltipLabelFormatter || tooltipDateFormatter;

  return (
      <>
        {formattedData.length > 0 &&
          <ResponsiveContainer width={containerWidth} height={containerHeight}>
            <AreaChart data={formattedData}
                       onMouseDown={(e) => e && setRefAreaLeft(e.activeLabel)}
                       onMouseMove={(e) => e && refAreaLeft && setRefAreaRight(
                           e.activeLabel)}
                       onMouseUp={(e) => zoom()}    minWidth
                       margin={{
                         top: 10,
                         right: 10,
                         bottom: 10,
                         left: 0,
                       }}>
              <CartesianGrid strokeDasharray="3 3"/>
              <XAxis
                  dataKey='timestamp'
                  domain={([dataMin, dataMax]) => {
                    const offset = zoomIntervalMillis / 50;
                    return [dataMin - offset, dataMax + offset];
                  }}
                  name='Time'
                  ticks={xAxisTicks}
                  tickFormatter={xAxisTickFormatter}
                  type='number'
              />
              <YAxis yAxisId="0" orientation="left"
                     ticks={yAxisTicks}
                     tickFormatter={yAxisFormatter}
                     name={yAxisName} domain={yAxisDomain} label={{
                value: yAxisName,
                angle: -90,
                position: "insideLeft",
                offset: 10
              }} unit={areaUnit}/>

              <Area
                  data={formattedData}
                  dataKey={seriesName}
                  animationDuration={500}
                  fill={color}
                  stroke={color}
                  strokeWidth={2}
                  dot={false}
                  yAxisId="0"
                  name={areaName}
                  type="stepAfter"
                  unit={areaUnit}
              />

              {refAreaLeft && refAreaRight ? (
                  <ReferenceArea yAxisId="0" x1={refAreaLeft} x2={refAreaRight}
                                 strokeOpacity={0.3}/>
              ) : null}

              <Tooltip
                  offset={30}
                  formatter={tooltipFormatter}
                  labelFormatter={tooltipLabelFormatter}
              />
            </AreaChart>
        </ResponsiveContainer>
        }
      </>
  );
};

export default SmartPlugAreaChart;

